import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { getTheme } from '../../../publicSession/selectors';
import { ThemeOptions } from '@wix/da-react-context/pkg/constants';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink/PlainButtonOrLink';
import { useTranslation } from 'react-i18next';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
import s from './ThemeToggle.scss';
export default (({ className, toggleTheme })=>{
    const theme = useSelector(getTheme);
    const [currentTheme, setCurrentTheme] = useState(theme);
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        "aria-label": t('siteHeader.userMenu.themeDark'),
        "aria-pressed": theme === ThemeOptions.DARK,
        tabIndex: 0,
        onClick: ()=>{
            setCurrentTheme(theme === ThemeOptions.LIGHT ? ThemeOptions.DARK : ThemeOptions.LIGHT);
            yieldToMain(toggleTheme);
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], currentTheme === ThemeOptions.LIGHT && s['day'], className)
    }, /*#__PURE__*/ React.createElement("label", {
        className: s['toggle'],
        htmlFor: "checkbox"
    }, /*#__PURE__*/ React.createElement("i", {
        className: s['star']
    }), /*#__PURE__*/ React.createElement("i", {
        className: s['star']
    }), /*#__PURE__*/ React.createElement("i", {
        className: s['star']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['star-trail']
    })), /*#__PURE__*/ React.createElement("i", {
        className: s['star']
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['disc']
    }, /*#__PURE__*/ React.createElement("i", null)), /*#__PURE__*/ React.createElement("span", {
        className: classnames(s['cloud'], s['cloud1'])
    }), /*#__PURE__*/ React.createElement("span", {
        className: classnames(s['cloud'], s['cloud2'])
    }))));
});
